import React from 'react';
import { Switch, Route } from 'react-router-dom';

import PrivateRoute from './components/route/PrivateRoute';

import Home from './screens/Home';
import Applications from './screens/Applications';
import AppDetail from './screens/AppDetail';
import Admin from './navigation/AdminNavigation';

import './App.scss';
import 'dayjs/locale/es';

function App() {
  return (
    <Switch>
      <Route exact path="/">
        <Home />
      </Route>
      <PrivateRoute path="/store/admin">
        <Admin />
      </PrivateRoute>
      <PrivateRoute path="/store/app/:appid">
        <AppDetail />
      </PrivateRoute>
      <PrivateRoute path="/store">
        <Applications />
      </PrivateRoute>
    </Switch>
  );
}

export default App;
